 
import WebOffice from '../../../webOffice/index'; 
export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'报表列表', path:''
            },{
                name:'报表详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/rePort/save',//保存
                bykey:'oa/official/rePort/byKey',//详情 
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editObj:{
                title:"",
                fileKey:"", 
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件 
            userWnd: false,//是否显示人员选择窗口
            rules:{ 
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }], 
            },
            fileNumList:[],
            webShow:false,
            WFtask:{}, 
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String, 
    },
   
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                             
    methods: {
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;   
                }
            })
        }, 
        goBack(){ 
            this.$router.go(-1);
        },  
        editDoc(){
            //this.webShow=true;
            let {href}  = this.$router.resolve({ 
                path: "/oa/office/browerDialog",
                query:{
                    isView:1,
                    bizKey:this.key,
                    fileType:".xlsx",
                    bizType:5,
                    fileId:this.editObj.fileKey 
                }
            })    
            this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
            
        },
        callback(){

        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/rePort/view/view.js